import { render } from "./debugging.md?vue&type=template&id=5292b04b"
import script from "./debugging.md?vue&type=script&lang=js"
export * from "./debugging.md?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__